import React, { useState } from "react";
import Button from "components/UI/Button";
import Details from "./Details";
import styles from "./styles.module.scss";
import { track } from "../../../utils/amplitude";
import PlanSwitcher from "../PlanSwitcher";
import Link from "next/link";

const free = [
  {
    id: "1",
    description: "Integrate and handle cross-platform in-app subscriptions",
  },
  {
    id: "2",
    description: "Validate App Store and Google Play receipts ",
  },
  {
    id: "3",
    description: "Implement subscription offers with no server code",
  },
  {
    id: "4",
    description: "Revenue analytics",
  },
  {
    id: "5",
    description: "Understand why customers cancel subscriptions",
  },
  {
    id: "6",
    description: "Run A/B experiments to test different in-app purchase prices",
    // soon: true,
  },
];

const launch = [
  {
    id: "1",
    description: "Integrate and handle cross-platform in-app subscriptions",
  },
  {
    id: "2",
    description: "Validate App Store and Google Play receipts ",
  },
  {
    id: "3",
    description: "Implement subscription offers with no server code",
  },
  {
    id: "4",
    description: "Revenue analytics",
  },
  {
    id: "5",
    description: "Understand why customers cancel subscriptions",
  },
  {
    id: "6",
    description: "Run A/B experiments to test different in-app purchase prices",
    // soon: true,
  },
];

const grow = [
  {
    id: "1",
    description: "Integrate and handle cross-platform in-app subscriptions",
  },
  {
    id: "2",
    description: "Validate App Store and Google Play receipts ",
  },
  {
    id: "3",
    description: "Implement subscription offers with no server code",
  },
  {
    id: "4",
    description: "Revenue analytics",
  },
  {
    id: "5",
    description: "Understand why customers cancel subscriptions",
  },
  {
    id: "6",
    description: "Run A/B experiments to test different in-app purchase prices",
  },
];

const Pricing = ({ planType, setPlanType }) => {
  const period = planType ? "annually" : "monthly";
  return (
    <div className={styles.pricing}>
      <div className="container">
        <div className={styles.items}>
          <div className={styles.item}>
            <div className={styles.wrap}>
              <div className={styles.priceWrapper}>
                <div className={styles.label}>Free</div>
                <div>
                  <span>$</span>
                  <span className={styles.digitMargin}>0</span>
                  <span>/mo</span>
                </div>
              </div>
              <div className={styles.img}>
                <span className={styles.span_margin}>$10,000 MTR included</span>
              </div>
              <div className={styles.list}>
                <span>Cross-platform in-app purchases infrastructure</span>
                <span>Real-time revenue analytics</span>
                <span>
                  Precise proceeds tracking (VAT + Apple exchange rate)
                </span>
                <span>Remote products configuration</span>
                <span>1 seat available</span>
                <span>Email and community support</span>
              </div>
              <a
                href="https://app.apphud.com/sign_up"
                onClick={() =>
                  track("pricing_plan_button_clicked", { plan: "free", period })
                }
              >
                <Button title="Start for free" transparent border />
              </a>

              <Details items={free} />
            </div>
          </div>

          <div className={styles.isMobile}>
            <PlanSwitcher
              value={planType}
              onChange={(v) => setPlanType(Number(v))}
            />
          </div>

          <div className={styles.item}>
            <div className={styles.wrap}>
              <div className={styles.priceWrapper}>
                <div className={styles.label}>Pro</div>
                <div>
                  <span>$</span>
                  <span className={styles.digitMargin}>{49}</span>
                  <span>/mo</span>
                </div>
              </div>
              <div className={styles.img}>
                <span>
                  $5,000 MTR included <br /> free until $1,000 MTR
                </span>
              </div>
              <div className={styles.list}>
                <span aria-label={true}>
                  <b>All from Free plan and…</b>
                </span>
                <span>5 seats</span>
                <span>Advanced reports (Renewals Performance, Free Trials Performance, Refund Requests, etc.)</span>
                <span>Saved charts</span>
                <span>Experiments</span>
                <span>Placements in experiments</span>
                <span>Rules</span>
                <span>Integrations</span>
                <span>ASA-attribution</span>
                <span>Custom user audiences</span>
                <span>Online chat support</span>
                <span>Customers API</span>
              </div>
              <a
                href="https://app.apphud.com/sign_up?plan=start"
                onClick={() =>
                  track("pricing_plan_button_clicked", {
                    plan: "start",
                    period,
                  })
                }
              >
                <Button title="Choose plan" transparent border />
              </a>
              <Details items={free} />
            </div>
          </div>

          <div className={`${styles.item} ${styles.bestChoice}`}>
            <div className={styles.wrap}>
              <div className={styles.priceWrapper}>
                <div className={styles.label}>
                  Expert
                  <span className={styles.tag}>Best Choice</span>
                </div>
                <div>
                  <span>$</span>
                  <span className={styles.digitMargin}>{59}</span>
                  <span>/mo</span>
                </div>
              </div>
              <div className={styles.img}>
                <span>
                  $5,000 MTR included <br /> free until $1,000 MTR
                </span>
              </div>
              <div className={styles.list}>
                <span aria-label={true}>
                  <b>All from Pro plan and…</b>
                </span>
                <span>LTV Predictions</span>
                <span>Connection Builder</span>
                <span>Server-to-Server Webhooks</span>
                <span>Daily Data Exports</span>
                <span>Custom user properties segmentation</span>
                <span>10 seats</span>
                <span>Higher priority online-chat support</span>
                <span>Prioritized feature requests</span>
                <span>Assisted onboarding</span>
                <span>New features early access</span>
              </div>
              <a
                href="https://app.apphud.com/sign_up?plan=start"
                onClick={() =>
                  track("pricing_plan_button_clicked", {
                    plan: "start",
                    period,
                  })
                }
              >
                <Button title="Choose plan" transparent border />
              </a>
              <Details items={free} />
            </div>
          </div>

          <div className={styles.item}>
            <div className={`${styles.wrap} ${styles.dark}`}>
              <div className={styles.priceWrapper}>
                <div className={styles.label}>Enterprise</div>
                <div>Premium</div>
              </div>
              <div className={styles.img}>
                <span className={styles.span_margin}>$100,000+ MTR </span>
              </div>
              <div className={styles.list}>
                <span aria-label={true}>
                  <b>All from Expert plan and…</b>
                </span>
                <span>On-demand raw data exports</span>
                <span>Premium support</span>
                <span>Volume discounts</span>
                <span>Personal onboarding</span>
                <span>Dedicated support manager </span>
                <span>One-on-one sessions with Apphud experts</span>
              </div>
              <Link
                href="/contact"
                onClick={() =>
                  track("pricing_plan_button_clicked", { plan: "grow", period })
                }
              >
                <Button title="Contact us" />
              </Link>
              <Details items={grow} />
            </div>
          </div>
        </div>
      <div className={styles.addOn}>
        <div className={styles.addOnItem}>
          <div className={styles.addOnItemTitle}>
            <h3>Win back refunds add-on</h3>
          </div>
          <div className={styles.addOnItemDescription}><span>Streamline your refund management process and reduce revenue
            loss with automated responses to Apple’s App Store refund requests.</span>
            <Link
                href="/contact"
                onClick={() =>
                  track("pricing_plan_button_clicked", { plan: "grow", period })
                }
              >
                <Button title="Contact us" />
              </Link></div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Pricing;
